<template>
  <span class="masked-phone">
    <template v-if="prefix">{{ prefix }}</template>{{ maskedValue }}
  </span>
</template>

<script>
export default {
  name: 'MaskedPhone',
  props: {
    // 手机号原始值
    phone: {
      type: [String, Number],
      default: ''
    },
    // 前缀文案，如 "电话："、不需要传空字符串则不显示
    prefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 是否需要脱敏：登录手机号为 18611955177 且账号身份 wildcard 为 ZC 时加密
    shouldMask () {
      return this.$store && this.$store.state.loginPhone === '18611955177' && this.$store.state.flag === 'ZC'
    },
    maskedValue () {
      const raw = String(this.phone == null ? '' : this.phone).trim()
      if (!raw) return '-'
      // 非脱敏模式，直接返回原始值
      if (!this.shouldMask) return raw
      // 只保留数字
      const digits = raw.replace(/\D/g, '')
      if (digits.length < 7) return raw
      // 中间 4 位替换为 ****
      const start = digits.slice(0, 3)
      const end = digits.slice(-4)
      return `${start}****${end}`
    }
  }
}
</script>
